// This file was auto-generated by Fern from our API Definition.
import * as FernIr from "../../../index.mjs";
export const StreamingResponse = {
    json: (value) => {
        return Object.assign(Object.assign({}, value), { type: "json", _visit: function (visitor) {
                return FernIr.StreamingResponse._visit(this, visitor);
            } });
    },
    text: (value) => {
        return Object.assign(Object.assign({}, value), { type: "text", _visit: function (visitor) {
                return FernIr.StreamingResponse._visit(this, visitor);
            } });
    },
    sse: (value) => {
        return Object.assign(Object.assign({}, value), { type: "sse", _visit: function (visitor) {
                return FernIr.StreamingResponse._visit(this, visitor);
            } });
    },
    _visit: (value, visitor) => {
        switch (value.type) {
            case "json":
                return visitor.json(value);
            case "text":
                return visitor.text(value);
            case "sse":
                return visitor.sse(value);
            default:
                return visitor._other(value);
        }
    },
};
